import { useEffect, useState } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";
import FnrEnrichedCheckbox, {
  FnrCheckboxIcon,
  FnrCheckboxSubtext,
  FnrCheckboxText,
} from "UI/FnrEnrichedCheckbox";

import useTimeout from "Utilities/Hooks/useTimeout";

import { Description, Subtitle } from "../..";

export function CostsMoney({
  setTab,
  setCostsMoney,
  setIsSuggestedDonation,
  isLoading,
  saveNewSignup,
  entity,
}) {
  const [stagedValue, setStagedValue] = useState();

  const navigateToPricing = () => {
    setTimeout(() => setTab("pricing"), 625);
  };

  useEffect(() => {
    switch (stagedValue) {
      case "free":
        setCostsMoney(false);
        break;
      case "fixed":
        setIsSuggestedDonation(false);
        setCostsMoney(true);
        break;
      case "donation":
        setIsSuggestedDonation(true);
        setCostsMoney(true);
        break;
      default:
        break;
    }
  }, [stagedValue]);

  return (
    <Wrapper>
      <Subtitle>Would you like to take payments with this Signup?</Subtitle>

      <FnrEnrichedCheckbox
        on={stagedValue === "free"}
        toggleOn={() => setStagedValue("free")}
        style={{ paddingLeft: 8 }}
        checkSide="left"
      >
        <FnrCheckboxText>Make it free to sign up</FnrCheckboxText>
      </FnrEnrichedCheckbox>

      <FnrEnrichedCheckbox
        on={stagedValue === "fixed"}
        toggleOn={() => {
          setStagedValue("fixed");
          navigateToPricing();
        }}
        style={{ paddingLeft: 8 }}
        checkSide="left"
      >
        <FnrCheckboxText>Charge a fixed amount</FnrCheckboxText>
        <CheckboxSubtext>
          {`Respondents must pay a set amount to sign up. You can charge per ${entity} or per household.`}
        </CheckboxSubtext>
      </FnrEnrichedCheckbox>

      <FnrEnrichedCheckbox
        on={stagedValue === "donation"}
        toggleOn={() => {
          setStagedValue("donation");
          navigateToPricing();
        }}
        style={{ paddingLeft: 8 }}
        checkSide="left"
      >
        <FnrCheckboxText>Suggest a donation</FnrCheckboxText>
        <CheckboxSubtext>
          {
            "You'll be able to set a suggested donation and we'll prompt respondents to donate when they sign up."
          }
        </CheckboxSubtext>
      </FnrEnrichedCheckbox>

      <ButtonHolder>
        <ButtonHolderInside
          initial={{ opacity: 0, scale: 0.8 }}
          animate={
            stagedValue === "free"
              ? { opacity: 1, scale: 1 }
              : { opacity: 0, scale: 0.8, transition: { type: "tween" } }
          }
        >
          <FnrButton
            disabled={!stagedValue}
            data-cy="CostMoney_GoButton"
            color="blue"
            onClick={saveNewSignup}
            loading={isLoading}
          >
            <ButtonText>{"Let's Go"}</ButtonText>
          </FnrButton>
        </ButtonHolderInside>
      </ButtonHolder>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 24px;
`;
const ButtonHolder = styled.div`
  padding-top: 24px;
  display: flex;
  justify-content: flex-end;
`;
const ButtonHolderInside = styled(motion.div)``;

const CheckboxSubtext = styled(FnrCheckboxSubtext)`
  font-weight: 400;
  color: #828c8d;
`;
